import { SET_TOGGLE_SIDEBAR, SIGN_OUT,SAVE_RESULT_NRW_CALCULATE,
    STORE_DATA_NRW_BY_DMA, STORE_LIST_DMA_FOR_SELECT,
    STORE_SEARCH_MONTH,STORE_SEARCH_YEAR, STORE_SEARCH_DMA } from './type'

export function setToggleSidebar(isOpen) {
    return {
        type: SET_TOGGLE_SIDEBAR,
        payload: isOpen
    }
}

export function signOut(){
    return {
        type: SIGN_OUT
    }
}

export function saveResutNRWCalculate(resultCalculate){
    return {
        type: SAVE_RESULT_NRW_CALCULATE,
        payload: resultCalculate
    }
}

export function storeNRWByDMA(dataNRWByDMA){
    return {
        type: STORE_DATA_NRW_BY_DMA,
        payload: dataNRWByDMA
    }
}

export function storeListDMAForSelect(listDMAForSelect){
    return {
        type: STORE_LIST_DMA_FOR_SELECT,
        payload: listDMAForSelect
    }
}

export function storeSearchMonth(searchMonth){
    return {
        type: STORE_SEARCH_MONTH,
        payload: searchMonth
    }
}

export function storeSearchYear(searchYear){
    return {
        type: STORE_SEARCH_YEAR,
        payload: searchYear
    }
}

export function storeSearchDMA(searchDMA){
    return {
        type: STORE_SEARCH_DMA,
        payload: searchDMA
    }
}